export default function (search, replacement, options) {
  return options.fn(this).replace(search, replacement);
}
